import RRS from 'constants/recurrence/recurrenceRuleSimplified.const';

const RECURRENCE_DESCRIPTION = Object.freeze({
  null: 'Only today',
  [RRS.onlyOnce]: 'No repeat',
  [RRS.every1Day]: 'Repeats daily',
  [RRS.every1Week]: 'Repeats every week',
  [RRS.every2Weeks]: 'Repeats every two weeks',
  [RRS.every4Weeks]: 'Repeats every four weeks',
  [RRS.every6Weeks]: 'Repeats every six weeks',
});

export default RECURRENCE_DESCRIPTION;
